import { render, staticRenderFns } from "./CopyableDemo.vue?vue&type=template&id=42bf0daa&scoped=true&"
import script from "./CopyableDemo.vue?vue&type=script&lang=js&"
export * from "./CopyableDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf0daa",
  null
  
)

export default component.exports